export default "__VITE_ASSET__BdpzQY3___"